import React from 'react'
import classNames from 'classnames'
import clamp from 'lodash-es/clamp'

import { withStyles, Typography, createStyles, WithStyles, Theme } from '@material-ui/core'

import AchievementBadge from '../AchievementBadge'

interface Props {
  level: number
}

const styles = (theme: Theme) => createStyles({
  root: {
    margin: '0 auto',
    borderRadius: '150%',
    textTransform: 'uppercase',
    border: '4px solid',
    borderColor: theme.palette.grey['100'],
    width: 120,
    height: 120,
    background: `linear-gradient(135deg, transparent 0% 50%, #EAEFF5 50% 100%)`,
  },
  title: {
    margin: '10% auto 5%',
    fontSize: 9,
    fontWeight: 500,
    letterSpacing: 3,
  },
  locked: {
    borderColor: '#EAEFF5',
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const AchievementStatus: React.SFC<InjectedProps> = ({ level, classes }) => {
  level = clamp(level | 0, 0, 6) // tslint:disable-line:no-bitwise

  const isLocked = level === 0

  return (
    <div className={classNames(classes.root, { [classes.locked]: isLocked })}>
      <Typography variant="h3" align="center" className={classes.title}>
        {isLocked ? 'LOCKED' : 'LEVEL'}
      </Typography>
      <AchievementBadge level={level} />
    </div>
  )
}

export default withStyles(styles)(AchievementStatus)
